<div class="filters-v2-wrapper" [ngClass]="{ 'is-mobile': isMobile }">
  <div class="filters-v2-content gap-x-4">
    <app-filter-v2-cbsas
      (applyFilters)="applyFilters($event)"
    ></app-filter-v2-cbsas>

    <app-filter-v2-status
      *ngIf="!isMobile"
      (applyFilters)="applyFilters($event)"
    >
    </app-filter-v2-status>

    <!-- <app-filter-v2-financials
      *ngIf="!isMobile"
      (applyFilters)="applyFilters($event)"
    ></app-filter-v2-financials> -->

    <app-filter-v2-price
      *ngIf="!isMobile"
      (applyFilters)="applyFilters($event)"
    ></app-filter-v2-price>

    <app-filter-v2-subtype
      *ngIf="!isMobile"
      (applyFilters)="applyFilters($event)"
    ></app-filter-v2-subtype>

    <app-filter-v2-more
      *ngIf="isMobile"
      (applyFilters)="applyFilters($event)"
    ></app-filter-v2-more>

    <app-filter-v2-more-desktop
      *ngIf="!isMobile"
      (applyFilters)="applyFilters($event)"
    ></app-filter-v2-more-desktop>

    <div class="clear-all" (click)="clearFilters()">Reset all</div>
  </div>
</div>
